import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

export const getAffiliateFilterFields = (): FieldSettings[] => [
  {
    name: 'Code',
    label: 'Code',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
    ],
  },
]
